import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import PropTypes from 'prop-types';

import { Audio } from './Views/Audio';
import { DefaultView } from './Views/Default';
import { Event } from './Views/Event';
import { FileListing } from './Views/File';
import { Image } from './Views/Image';
import { NewsItem } from './Views/NewsItem';
import { Video } from './Views/Video';

export const mappingTypes = {
  'News Item': NewsItem,
  File: FileListing,
  Event: Event,
  Audio: Audio,
  Video: Video,
  Image: Image,
};

const SpecificTemplate = ({
  items,
  linkTitle,
  linkHref,
  isEditMode,
  hideImage = false,
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <div>
        <ul className="listing-style-none pl-0 mr-0">
          {items.map((item, index) => {
            const { '@type': type, url } = item;
            const SpecificComponent = mappingTypes[type] || DefaultView;

            return (
              <li key={item['@type']}>
                <div
                  className="br-item py-3 px-0 b-0 border-bottom"
                  key={`${url}-${index}`}
                >
                  <SpecificComponent item={item} isEditMode={isEditMode} />
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SpecificTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default SpecificTemplate;
